import moment from 'moment-timezone'

function getWeekday(date, locale = 'en') {
    if (!date) {
        return null
    }
    const momentDate = moment(date)
    return momentDate.isValid()
        ? momentDate.locale(locale).format('dddd')
        : null
}

function hoursAndMinutesDuration(seconds) {
    if (typeof seconds !== 'number') {
        return null
    }
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.round(seconds / 60) - hours * 60
    return hours
        ? minutes
            ? `${hours}h ${minutes}min`
            : `${hours}h`
        : `${minutes}min`
}

// convert time from HH:mm:ss format to X hours Y minutes Z seconds
function convertTime(timeSpan) {
    if (
        !timeSpan ||
        typeof timeSpan !== 'string' ||
        !/^\d{1,2}:\d{2}:\d{2}$/m.test(timeSpan)
    ) {
        return '-'
    }
    const parts = timeSpan.split(':')
    const hours = parseInt(parts[0], 10)
    const minutes = parseInt(parts[1], 10)
    const seconds = parseInt(parts[2], 10)

    return hoursAndMinutesDuration(hours * 3600 + minutes * 60 + seconds)
}

// Converts a number to 1k representative.
// Taken from https://stackoverflow.com/questions/9461621/format-a-number-as-2-5k-if-a-thousand-or-more-otherwise-900.
function kFormatter(num) {
    return Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + 'k'
        : Math.sign(num) * Math.abs(num)
}

function formatDistance(distance = 0, fractionDigits = 2) {
    return distance >= 1000
        ? `${(distance / 1000).toFixed(fractionDigits)}km`
        : `${distance}m`
}

const driverTimeFormatters = {
    work_start_time: time =>
        time
            ? moment
                  .utc(time, 'HH:mm:ss')
                  .local()
                  .format('LT')
            : '',
    cumulative_break_time: convertTime,
    current_daily_driving_time: convertTime,
    work_time_total: convertTime,
    remaining_time_until_next_break: convertTime,
    remaining_time_current_shift: convertTime,
    time_left_until_new_daily_rest_period: convertTime,
}

export default {
    getWeekday,
    convertTime,
    hoursAndMinutesDuration,
    kFormatter,
    formatDistance,
    driverTimeFormatters,
}
